import React from 'react';
import { Stack, Typography } from '@mui/material';

import { Content, IconWrapper } from './styles';
import { parseCareCenterAddress } from './utils';

import { ReactComponent as LinkIcon } from 'images/shared/link-simple.svg';
import { ReactComponent as LinkEnrolledIcon } from 'images/shared/link-enrolled.svg';

const Card = ({ name, address, isEnrolled = false, ...rest }) => {
  return (
    <Content
      isEnrolled={isEnrolled} {...rest}>
      <Stack
        spacing='2px' flex={1}>
        <Typography
          variant='pb3' color='primary.gray100'>
          {name}
        </Typography>
        <Typography
          variant='pl5' color='primary.gray50'>
          {parseCareCenterAddress(address)}
        </Typography>
      </Stack>
      <IconWrapper>
        {isEnrolled ? <LinkEnrolledIcon /> : <LinkIcon />}
      </IconWrapper>
    </Content>
  );
};

export default Card;
